import React, { FC } from "react";

const ModalFooter: FC = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};

export default ModalFooter;
